export const routeNames = {
    root: '/',
    home: 'home',
    auth: 'auth',
    howItWorks: 'how-it-works',
    userManagement: 'user-management',
    administration: 'administration',
    translations: 'translations',
    sitesManagement: 'sites-management',
    equipment: 'equipment',
    equipmentImport: 'equipment-import'
};
